import { ColumnConfig } from "../../../components/common/GenericTable";
import { WorkflowData, WorkflowDetailData } from "../../../types/Workflow";

export const getWorkflowTableColumns: ColumnConfig<WorkflowData>[] = [
  { key: "id", label: "Id", searchable: true },
  {
    key: "transactions",
    label: "Transaction",
    searchable: true,
    render: (row) => row.transactions?.name || "N/A",
  },
  { key: "name", label: "Name", searchable: true },
  { key: "description", label: "Description", searchable: true },
];

export const getWorkflowDetailTableColumns = (
  roleData: any[]
): ColumnConfig<WorkflowDetailData>[] => [
  { key: "id", label: "Id", searchable: true },
  { key: "location", label: "Location", searchable: true },

  {
    key: "roleId",
    label: "Role",
    searchable: true,
    render: (row) => {
      const role = roleData.find((r) => r.id === row.roleId);
      return role ? role.name : "N/A";
    },
  },

  { key: "taskLevel", label: "Task Level", searchable: true },
  {
    key: "statusId",
    label: "Status",
    searchable: true,
    render: (row) => row.statuses?.name || "N/A",
  },
  {
    key: "canSkip",
    label: "Can Skip",
    searchable: true,
    render: (row) => (row.canSkip ? "YES" : "NO"),
  },
  {
    key: "canSend",
    label: "Can Send",
    searchable: true,
    render: (row) => (row.canSend ? "YES" : "NO"),
  },
];
